if(typeof __WEBPACK_EXTERNAL_MODULE__902__ === 'undefined') {var e = new Error("Cannot find module 'esprima'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__902__;